import { render, staticRenderFns } from "./WorkApprovalProductionsGrid.vue?vue&type=template&id=e4973794&scoped=true"
import script from "./WorkApprovalProductionsGrid.vue?vue&type=script&lang=js"
export * from "./WorkApprovalProductionsGrid.vue?vue&type=script&lang=js"
import style0 from "./WorkApprovalProductionsGrid.vue?vue&type=style&index=0&id=e4973794&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4973794",
  null
  
)

export default component.exports